// extracted by mini-css-extract-plugin
module.exports = {"user":"user_user__264uy"};